import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { logger } from 'v2/utils/logger'

export function formatPhoneNumberWithExtension(phoneNumber: string): {
  formattedNumber: string | null
  extension?: string
} {
  try {
    // Check for the sip endpoint
    if (phoneNumber.startsWith('sip:')) {
      return {
        formattedNumber: phoneNumber,
        extension: '',
      }
    }

    const formatted = phoneNumber.replace(/[-()\s]/g, '')
    const parsedNumber = parsePhoneNumberFromString(formatted)
    if (!parsedNumber) return { formattedNumber: null }

    const extension = parsedNumber.ext
    const numberWithoutExt = parsedNumber.number
    const formattedNumber = numberWithoutExt

    return {
      formattedNumber,
      extension,
    }
  } catch (e) {
    logger.error('Error formatting phone number', { error: e })
    return { formattedNumber: null }
  }
}

export function isAnonymousCallerId(callerId: string): boolean {
  const anonymousCallerIds = ['anonymous', 'restricted', 'private', 'unavailable']
  return anonymousCallerIds.includes(callerId.toLowerCase())
}
